import {useScrollbarWidth} from '@logistics-frontend/utils'
import {useEffect, useId} from 'react'

import {classes} from './classes'
import {scrollbarWidthToken} from './const'

type Lock = Record<string, boolean>

const sharedLock: Lock = {}

const addToLock = (lock: Lock, id: string, element: HTMLElement) => {
  lock[id] = true

  element.classList.add(classes.noScroll)
  if (element.scrollHeight > Math.min(element.clientHeight, window.innerHeight)) {
    document.body.classList.add(classes.scrollbarPadding)
  }
}
const removeFromLock = (lock: Lock, id: string, element: HTMLElement) => {
  lock[id] = false
  if (Object.values(lock).filter(Boolean).length === 0) {
    element.classList.remove(classes.noScroll, classes.scrollbarPadding)
  }
}

export function useScrollLock(shouldLock: boolean = true, target: HTMLElement = document.body) {
  const id = useId()
  const scrollbarWidth = useScrollbarWidth()

  useEffect(() => {
    document.body.style.setProperty(scrollbarWidthToken, `${scrollbarWidth}px`)

    if (shouldLock) {
      addToLock(sharedLock, id, target)
    } else {
      removeFromLock(sharedLock, id, target)
    }
    return () => {
      removeFromLock(sharedLock, id, target)
    }
  }, [id, scrollbarWidth, shouldLock, target])
}
